
export default function BasicSpecs() {
  const specs = [
    { label: 'カード名', value: '地方銀行系スピード発行カード（一般カード）' },
    { label: '年会費', value: '1,375円（税込）※スピード発番初年度無料、ご利用金額により翌年も無料' },
    { label: 'ポイント還元率', value: '0.5%（優待店で2〜20倍）' },
    { label: '国際ブランド', value: '国際ブランド対応' },
    { label: '申込条件', value: '18歳以上で本人または配偶者に安定継続収入のある方、または高校生を除く18歳以上の学生' },
    { label: '発行スピード', value: '最短5分（スピード発番「スピ発」対応）' },
    { label: 'ポイント名', value: '提携ポイントプログラム' },
    { label: 'ポイント有効期限', value: '獲得月から2年間' },
    { label: '電子マネー', value: 'QUICPay / Apple Pay / Google Pay' },
    { label: '海外旅行傷害保険', value: '最高3,000万円（利用付帯）' },
    { label: '国内旅行傷害保険', value: '最高3,000万円（利用付帯）' },
    { label: 'スマートフォン保険', value: '年間最高30,000円（自己負担10,000円）' },
    { label: 'ショッピングガード保険', value: '海外：最高100万円' },
    { label: 'ETCカード', value: '年会費無料' },
    { label: '家族カード', value: '年会費440円（税込）' },
    { label: 'タッチ決済', value: 'タッチ決済対応' },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-8 text-center">
          地方銀行系スピード発行カードの基本スペック
        </h2>
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
          <table className="w-full">
            <tbody>
              {specs.map((spec, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-[#F8F9FA]' : 'bg-white'}>
                  <td className="px-6 py-4 text-sm font-bold text-gray-700 border-b border-gray-200 w-1/3">
                    {spec.label}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900 border-b border-gray-200">
                    {spec.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
